/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

// The editor creator to use.
import ClassicEditorBase from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';	// <-- Added by @dronpes on 6/3/2022

import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
// import UploadAdapter from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter';
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import Strikethrough from '@ckeditor/ckeditor5-basic-styles/src/strikethrough';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
// import CKFinder from '@ckeditor/ckeditor5-ckfinder/src/ckfinder';
// import EasyImage from '@ckeditor/ckeditor5-easy-image/src/easyimage';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
// import Image from '@ckeditor/ckeditor5-image/src/image';
// import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
// import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
// import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
// import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import Indent from '@ckeditor/ckeditor5-indent/src/indent';
import Link from '@ckeditor/ckeditor5-link/src/link';
import List from '@ckeditor/ckeditor5-list/src/list';
// import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice';
import Table from '@ckeditor/ckeditor5-table/src/table';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar';
import TextTransformation from '@ckeditor/ckeditor5-typing/src/texttransformation';
// import CloudServices from '@ckeditor/ckeditor5-cloud-services/src/cloudservices';

import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import AutoLink from '@ckeditor/ckeditor5-link/src/autolink';

import HSButton from '../hs-button/hsbutton';	// <-- Added by @dronpes on 6/3/2022
import Placeholder from "../hs-placeholder";	// <-- Added by @dronpes on 6/3/2022

export default class ClassicEditor extends ClassicEditorBase {}

// Plugins to include in the build.
ClassicEditor.builtinPlugins = [
	Essentials,
	// UploadAdapter,
	Autoformat,
	Bold,
	Italic,
	Underline,
	Strikethrough,
	BlockQuote,
	// CKFinder,
	// CloudServices,
	// EasyImage,
	Heading,
	// Image,
	// ImageCaption,
	// ImageStyle,
	// ImageToolbar,
	// ImageUpload,
	Indent,
	Link,
	List,
	// MediaEmbed,
	Paragraph,
	PasteFromOffice,
	Table,
	TableToolbar,
	TextTransformation,
	Placeholder,	// <-- Added by @dronpes on 6/3/2022
	Alignment,	// <-- Added by @dronpes on 6/3/2022
	AutoLink,	// <-- Added by @dronpes on 6/3/2022
	HSButton,	// <-- Added by @dronpes on 6/3/2022
];

// Editor configuration.
ClassicEditor.defaultConfig = {
	toolbar: {
		items: [
			'placeholder',
			'hsbutton',
			'alignment:left',
			'alignment:center',
			'alignment:right',
			'alignment:justify',
			// 'heading',
			// '|',
			'bold',
			'italic',
			// 'underline',
			'strikethrough',
			'link',
			'bulletedList',
			'numberedList',
			'|',
			'outdent',
			'indent',
			'|',
			// 'uploadImage',
			'blockQuote',
			'insertTable',
			// 'mediaEmbed',
			'undo',
			'redo',
			// Below this = added by @dronpes on 6/3/2022
		]
	},
	placeholderProps: {	// <-- Added by @dronpes on 6/3/2022
    types: [
			{
				name: "Client's First Name", 
				display: "Client's First Name"
			},
			{
				name: "Client's Last Name", 
				display: "Client's Last Name"
			}
		],
  },
	placeholderBrackets: {	// <-- Added by @dronpes on 6/3/2022
    open: "{",
    close: "}",
  },
	// image: {
		// toolbar: [
			// 'imageStyle:inline',
			// 'imageStyle:block',
			// 'imageStyle:side',
			// '|',
			// 'toggleImageCaption',
			// 'imageTextAlternative'
		// ]
	// },
	table: {
		contentToolbar: [
			'tableColumn',
			'tableRow',
			'mergeTableCells'
		]
	},
	// This value must be kept in sync with the language defined in webpack.config.js.
	language: 'en'
};
